import { render, staticRenderFns } from "./RetencaoVendas.vue?vue&type=template&id=bdb0e04c&scoped=true"
import script from "./RetencaoVendas.vue?vue&type=script&lang=js"
export * from "./RetencaoVendas.vue?vue&type=script&lang=js"
import style0 from "./RetencaoVendas.vue?vue&type=style&index=0&id=bdb0e04c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb0e04c",
  null
  
)

export default component.exports